export default "__VITE_ASSET__CveZrZRt__"